"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _formValidations = require("../../helpers/formValidations");
var _APInput = _interopRequireDefault(require("../common/APInput"));
var _APCryptoAddressInputContainer = _interopRequireDefault(require("../common/APCryptoAddressInput/APCryptoAddressInputContainer"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
require("./WhiteListAddressForm.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('whitelist-address-form');
var WhiteListAddressForm = function WhiteListAddressForm(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var invalid = props.invalid,
    submitting = props.submitting,
    ProductSymbol = props.ProductSymbol,
    handleSubmit = props.handleSubmit;
  var cryptoAddressRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAddressValid = _useState2[0],
    setIsAddressValid = _useState2[1];

  // Function to check and update address validity
  var checkAddressValidity = (0, _react.useCallback)(function () {
    if (cryptoAddressRef.current) {
      var currentValue = cryptoAddressRef.current.getValue();

      // Return false if address is empty, null, or undefined
      if (!currentValue || currentValue.trim() === '') {
        setIsAddressValid(false);
        return;
      }
      var isValid = cryptoAddressRef.current.isAddressValid();
      setIsAddressValid(isValid);
    } else {
      setIsAddressValid(false);
    }
  }, []);

  // Handle address input change
  var handleAddressChange = (0, _react.useCallback)(function () {
    // Small delay to allow the ref to update
    setTimeout(function () {
      return checkAddressValidity();
    }, 0);
  }, [checkAddressValidity]);
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('label-text'),
    style: {
      marginBottom: '1.4rem'
    }
  }, t('Add an address to the whitelist')), /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('label-text')
  }, t('Name')), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    name: "Name",
    label: "Name",
    customClass: (0, _cssClassesHelper.getBEMClasses)('send-form')(),
    validate: [_formValidations.required]
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('label-text')
  }, t('Address')), /*#__PURE__*/_react["default"].createElement(_APCryptoAddressInputContainer["default"], {
    ref: cryptoAddressRef,
    productSymbol: ProductSymbol,
    name: "AccountIdentifier",
    customClass: (0, _cssClassesHelper.getBEMClasses)('send-form')(),
    label: "Address",
    onChange: handleAddressChange
  }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    customClass: (0, _cssClassesHelper.getBEMClasses)('send-form')(),
    styleName: "additive",
    disabled: !isAddressValid || invalid || submitting
  }, t('Add to Whitelist')));
};
var _default = exports["default"] = WhiteListAddressForm;